module.exports = __webpack_public_path__ + "img/celebrating-hands-drawing.c3998512.png";